<template>
  <div id="main">

  <div id="header">
    <span>ダウンロードファイルをクリックしてください</span>
    <progress v-if="percentCompleted != 0" v-bind:value="percentCompleted" max="100"></progress>
  </div>

  <div id="grid-table-contents">
    <div v-if="isList" class="grid-table-scroll">
      <table class="table table-striped table-sm table-hover sticky_table">
        <thead>
          <tr class="table-primary">
            <th>ダウンロード済み</th>
            <th class="col-header-send">日付</th>
            <th class="col-header-file">zipファイル</th>
            <th class="col-header-file">備考</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(rowItem, rowIndex) in items"
            v-bind:key="rowIndex"
            v-bind:id = "'list' + rowItem.json.index"
            @click="itemInfo(rowItem.json.id, rowItem.json.items_cnt)"
            :style="checkedRowColor(rowItem.json.checked, rowItem.json.skiped)">
            <td><checkedTag :checked="rowItem.json.downloaded" /></td>
            <td class="col-send">{{rowItem.json.created_at}}</td>
            <td class="col-file">{{rowItem.json.name}}</td>
            <td class="col-file">{{registeCnt(rowItem.json.items_cnt)}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <span v-if="apiComplete">対象データがありません</span>
      <span v-else class="visually-hidden">Loading...</span>
    </div>
  </div>

  </div>
</template>

<script lang="ts">
import { ref, defineComponent, onMounted, computed, toRef } from 'vue'
import axios from 'axios'
import GetFileNameFromContentDisposition from '@/js/axiosEx.js'
import checkedTag from '@/components/checkedTag.vue'

export default defineComponent({
  components: {
    checkedTag
  },
  props: {
    sendIndex: {
      default: 0
    }
  },
  setup (props) {
    const items = ref([])
    const apiComplete = ref(false)
    const sendIndex = toRef(props, 'sendIndex')
    const shortName = ref(true)
    const filterIndex = ref(sendIndex.value)
    const percentCompleted = ref(0)

    // 配送方法フィルター
    const sendSelectOptions = ref([
      { code: 0, label: 'すべて', value: 0 },
      { code: 1, label: '未登録', value: 1 },
      { code: 2, label: '完了', value: 2 },
      { code: 3, label: '不明分', value: 3 }
    ])

    const sendTotal = ref([0, 0, 0, 0])

    const setListItems = () => {
      apiComplete.value = false
      axios.get('/api/putup/get_zipfile_records')
        .then((res) => {
          // console.log(res)
          items.value = res.data.records
        })
    }

    onMounted(() => {
      setListItems()
    })

    // Listデータの有無
    const isList = computed(() => {
      return items.value.length > 0
    })

    // 行の色
    const checkedRowColor = (checked, skiped) => {
      let rtn = {}
      if (checked) {
        if (skiped) {
          rtn = { background: '#FFC000' }
        } else {
          rtn = { background: '#C6EFCE' }
        }
      }
      return rtn
    }

    // 商品名の文字数
    const itemShow = (buf) => {
      let rtn = buf
      if (shortName.value && buf.length > 30) {
        rtn = rtn.substr(0, 30) + '…'
      }
      return rtn
    }

    // 登録数
    const registeCnt = (cnt) => {
      let rtn = ''
      if (cnt > 0) {
        rtn = '未登録: ' + String(cnt) + '冊'
      }
      return rtn
    }

    // 配送方法の表記
    const sendShow = (send) => {
      let rtn = ''
      switch (send) {
        case 0:
          rtn = 'ゆうメール'
          break
        case 1:
          rtn = 'ネコポス'
          break
        case 2:
          rtn = '指定分'
          break
        case 3:
          rtn = '同梱分'
          break
      }
      return rtn
    }

    const downloadProgress = (e) => {
      percentCompleted.value = Math.round((e.loaded * 100) / e.total)
    }

    const itemInfo = (id, cnt) => {
      // console.log('clicked')
      // 未登録商品があるならば確認する
      if (cnt > 0) {
        const res = window.confirm('棚番号が未登録の商品があります\nダウンロードしてもよろしいですか?')
        if (res === false) {
          return
        }
      }

      axios({
        method: 'POST',
        url: '/api/putup/download',
        data: { id: id },
        // dataType: 'binary',
        responseType: 'blob',
        headers: { Accept: 'application/zip' },
        onDownloadProgress: downloadProgress
      }).then((response) => {
        // リストの更新
        setListItems()

        const zipFile = response.data
        const blob = new Blob([zipFile], {
          type: 'application/zip'
        })

        const fileName = GetFileNameFromContentDisposition(response.headers['content-disposition'])

        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', fileName)
        link.click()
        percentCompleted.value = 0
      })
      // axios.get('/api/putup_download')
      // window.open('/api/putup_download')
      // router.push({ path: '/api/putup_download' })
      // router.push({ name: 'PutupChecker', params: { id: id, sendIndex: filterIndex.value } })
    }

    /*
    const itemInfoDebug = (id, cnt) => {
      // console.log('clicked')
      // 未登録商品があるならば確認する
      if (cnt > 0) {
        const res = window.confirm('棚番号が未登録の商品があります\nダウンロードしてもよろしいですか?')
        if (res === false) {
          return
        }
      }

      axios({
        method: 'POST',
        url: '/api/putup/download2',
        data: { id: id },
        // dataType: 'binary',
        responseType: 'blob',
        headers: { Accept: 'application/zip' },
        onDownloadProgress: downloadProgress
      }).then((response) => {
        // リストの更新
        setListItems()

        const zipFile = response.data
        const blob = new Blob([zipFile], {
          type: 'application/zip'
        })

        const fileName = GetFileNameFromContentDisposition(response.headers['content-disposition'])

        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', fileName)
        link.click()
        percentCompleted.value = 0
      })
      // axios.get('/api/putup_download')
      // window.open('/api/putup_download')
      // router.push({ path: '/api/putup_download' })
      // router.push({ name: 'PutupChecker', params: { id: id, sendIndex: filterIndex.value } })
    }
    */

    const clickedNameTitle = () => {
      shortName.value = !shortName.value
    }

    const changeSendSelect = () => {
      setListItems()
    }

    return {
      filterIndex,
      items,
      sendTotal,
      apiComplete,
      sendSelectOptions,
      isList,
      checkedRowColor,
      itemShow,
      sendShow,
      itemInfo,
      changeSendSelect,
      clickedNameTitle,
      registeCnt,
      percentCompleted
    }
  }
})
</script>
<style lang="scss" scoped>
#main {
  position: relative;
  height: 100%;
  width: 100%;

  #header {
    position: relative;
    top: 1.5rem;
    height: 20%;
    width: 100%;
  }

  #grid-table-contents {
    position: absolute;
    bottom : 10%;
    height: 80%;
    width: 100%;

    .grid-table-scroll {
      overflow-y: scroll;
      height: 100%;
      width: 100%;
      font-size: medium;

      .sticky_table {
        width: 100%;

        thead th {
          /* 縦スクロール時に固定する */
          position: sticky;
          top: 0;
          /* tbody内のセルより手前に表示する */
          z-index: 1;
        }
        td.col-file {
          white-space: nowrap;
        }
        td.col-send {
          white-space: nowrap;
        }
        td.col-shelf-number {
          white-space: nowrap;
        }
      }
    }
  }
}

</style>
